'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _PageContent = require('./PageContent');

var _PageContent2 = _interopRequireDefault(_PageContent);

var _ModalCloseButton = require('./ModalCloseButton');

var _ModalCloseButton2 = _interopRequireDefault(_ModalCloseButton);

var _ModalBackButton = require('./ModalBackButton');

var _ModalBackButton2 = _interopRequireDefault(_ModalBackButton);

require('./Modal.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Components


// Styles


var Modal = function (_React$Component) {
    _inherits(Modal, _React$Component);

    function Modal() {
        _classCallCheck(this, Modal);

        return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
    }

    _createClass(Modal, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            document.body.classList.add('modal');
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.classList.remove('modal');
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className,
                onClick = _props.onClick;


            return _react2.default.createElement(
                'div',
                { className: 'modal-container', onClick: onClick },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('Modal', className) },
                    _react2.default.createElement(_ModalBackButton2.default, this.props),
                    _react2.default.createElement(_ModalCloseButton2.default, this.props),
                    _react2.default.createElement(
                        _PageContent2.default,
                        { className: 'modal-content' },
                        children
                    )
                )
            );
        }
    }]);

    return Modal;
}(_react2.default.Component);

Modal.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]).isRequired,
    className: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    close: _propTypes2.default.func
};

exports.default = Modal;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/Modal.js
// module id = 712
// module chunks = 0